import React from 'react';
import PropTypes from 'prop-types';
import { Iterable } from 'immutable';

import './AlertWrapper.custom.scss';
import './AlertWrapper.theme.scss';

export default function AlertWrapper (props) {
  const { id, name, context, children } = props;

  return (
    <section id={id} data-alert-name={name} className={`alert-wrapper alert-context-${context}`}>
      {children}
    </section>
  );
}

AlertWrapper.propTypes = {
  id: PropTypes.string.isRequired,
  context: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array,
    PropTypes.instanceOf(Iterable),
  ]),
};
